module.exports = __webpack_public_path__ + "img/Button_GooglePlayOver-smv.059464db.png";